var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-chip"},_vm._l((_vm.tagList),function(tag){return _c('div',{key:tag,staticClass:"new-chip-item",style:(_vm.styles),attrs:{"text-color":"#007bff"},on:{"click":function($event){return _vm.isSinglePost(tag)}}},[_vm._v("\n    "+_vm._s(_vm.setValue(tag))+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fd938e0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/publication/tags.vue
// module id = 761
// module chunks = 0 1 3